import React from "react";
import EditEklokContainer from "../../containers/ekloks/EditEklokContainer";
import EditEklokForm from "../../forms/eklok/EditEklokForm";
import Modal from "../../components/Modal";
import { useTranslation } from "react-i18next";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";

const Edit = ({ handleClose, open, eklok }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <Modal
      fullScreen={matches}
      open={open}
      onClose={handleClose}
      title={t("edit_eklok.title")}
    >
      {eklok ? (
        <EditEklokContainer eklok={eklok}>
          {({ onSubmit, eklok }) => (
            <EditEklokForm onSubmit={onSubmit} initialValues={eklok} />
          )}
        </EditEklokContainer>
      ) : null}
    </Modal>
  );
};

export default Edit;
